module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/funabashi_concept_02-551cff052b646410431412ba7663c312.jpg";